const Price = ({ price, className }: { price: number; className?: string }) => {
  return (
    <span className={className}>
      {new Intl.NumberFormat('cs-CZ', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price)}
      &nbsp;Kč
    </span>
  )
}

export default Price
